import {ITheme} from './theme.interface';

export const Theme: ITheme = {
  name: 'Tema Afirma Solutions',
  version: '1.0.0',
  colors: {
    primaryColor: '#e99b38',
    secondaryColor: '#fed399',

    colorTextPrimary: '#646262',
    colorTextSecondary: '#e99b38',
    colorTextLight: '#ffffff',
    colorTextError: 'red',
    colorTextLink: '#646262',
    linkHoverColor: '#E99B38',

    colorPrimaryTable: '#ffffff',
    colorSecondaryTable: '#fed399',
    colorTableHeader: '#646262',
    colorTableRowHover: '#ccc',

    backgroundColor: '#e99b38',
    backgroundSecondary: '#fed399',
    backgroundCard: '#fff',
    backgroundModal: 'white',
    backgroundNavbar: '#fff',


    borderColor: '#e5e7eb',
    borderLight: '#e6e6e6',
    dividerColor: '#C4C4C4',

    colorResultNull: '#b2dcee',
    colorResultLow: '#6ddb81',
    colorResultMedium: '#f6cf0d',
    colorResultHigh: '#ea4203',
    colorResultVeryHigh: '#AB0844',

    colorReportNull: '#b2dcee',
    colorReportLow: '#6ddb81',
    colorReportMedium: '#f6cf0d',
    colorReportHigh: '#ea4203',
    colorReportVeryHigh: '#AB0844',

    colorTokenActive: '#6ddb81',
    colorTokenInactive: '#ea4203',
    colorTextTokenActive: '#646262',
    colorTextTokenInactive: '#fff',

    buttonPrimary: '#e99b38',
    buttonPrimaryHover: '#e99b38',
    buttonPrimaryText: '#646262',
    buttonPrimaryTextLight: '#ffffff', // COLOR TEXTO BOTON LOGIN
    buttonSecondary: '#646262',
    buttonSecondaryHover: ' #ffa726',
    buttonSecondaryText: '#646262',
    buttonDisabled: '#f3f4f6',
    buttonDisabledText: '#f3f4f6',
    buttonBorderColor: '#ffa726',
    buttonHoverBorderColor: '#ffa726',
    buttonFocusBorderColor: '#ffa726',

    buttonPrimaryLogin: '#201600', //COLOR LOGIN BOTON

    inputBorderColor: '#ffa726',
    inputFocusBorderColor: '#ffa726',
    inputFocusShadowColor: '#d1d5db',
    inputBackgroundColor: 'red',

    colorChartSuccess: '#6DDB81',
    colorChartDanger: '#AB0844',
    colorChartNeutral: '#C4C4C4',

    dropdownBorderColor: '#e5e7eb',
    dropdownFocusBorderColor: 'red', //Este falta de verificar
    dropdownSelectedItemBg: 'red',
    dropdownSelectedItemText: 'red',

    tooltipBackgroundColor: '#fff',
    tooltipTextColor: 'red',
    tooltipBorderColor: '#ddd',
    tooltipShadowColor: 'transparent',

    successColor: '#6DDB81',
    warnColor: '#E99B38',
    dangerColor: '#EA4203',
    deleteColor: 'red',

    iconColor: '#fff',
    shadowColor: ' #9ca3af',

    emptyStateBorderColor: '#DADDE1',
    emptyStateTextColor: '#646262',

    backgroundNavbarColor: '#fed399',

    colorWomen: '#FFAACE', //Se utiliza para la GUIA II grafica de persona identificadas por genero
    colorMen: '#B2DCEE', //Se utiliza para la GUIA II grafica de persona identificadas por genero

    fontFamily: 'Arial, sans-serif',
  },
  images: {
    companyLogo: {
      key: 'logo',
      path: '/assets/icons/Logo-afirma-color.png',
      alt: 'Logo Afirma Solutions',
      type: 'svg',
      fallback: '/assets/icons/Frame.svg',
      width: '180px',
    },
    companyLogoWhite: {
      key: 'logo.white',
      path: '/assets/icons/Logo-afirma-blanco.png',
      alt: 'Logo Afirma Solutions color blanco',
      type: 'svg',
      fallback: '/assets/icons/Logo-afirma-blanco.png',
    },
    companyLogoColor: {
      key: 'logo.color',
      path: '/assets/icons/Logo-afirma-color.png',
      alt: 'Logo Afirma Solutions color blanco',
      type: 'svg',
      fallback: '/assets/icons/Logo-afirma-color.png',
    },
    mobileLogo: {
      key: 'logo.header',
      path: '/assets/icons/Frame.svg',
      alt: 'Logo Afirma Solutions',
      type: 'svg',
      fallback: '/assets/icons/Frame.svg',
      width: '280px',
      height: '96px',
    },
  },
  customStyles: {
    "logo-nav-web-width": "180px",
    "logo-nav-mobile-width": "120px"
  },
  icons: {
    favicon: {
      key: 'favicon', //TODO: Solicitar favicon de la aplicación
      path: '/assets/icons/Logo-afirma-blanco.png',
      alt: 'favicon',
      svgString: '',
      colorable: false,
    },
    editIcon: {
      key: 'edit',
      path: '/assets/icons/edit.svg',
      alt: 'Icono de editar',
      svgString: '',
      colorable: false,
    },
    deleteIcon: {
      key: 'delete',
      path: '/assets/icons/delete.svg',
      alt: 'Icono de eliminar',
      svgString: '',
      colorable: false,
    },
    menuIcon: {
      key: 'menu',
      path: '/assets/icons/Menu.svg',
      alt: 'Icono de menú',
      svgString: '',
      colorable: false,
    },
    tablePreviousIcon: {
      key: 'table.previous',
      path: '/assets/botones-footer-table/anterior.svg',
      alt: 'Icono de tabla anterior',
      svgString: '',
      colorable: false,
    },
    tableNextIcon: {
      key: 'table.next',
      path: '/assets/botones-footer-table/siguiente.svg',
      alt: 'Icono de tabla siguiente',
      svgString: '',
      colorable: false,
    },
    officeBagIcon: {
      key: 'office.bag',
      path: '/assets/icons/office_bag.svg',
      alt: 'Icono de maletín de oficina',
      svgString: '',
      colorable: false,
    },
    arrowOneIcon: {
      key: 'arrow.one',
      path: '/assets/icons/flecha_1.svg',
      alt: 'Icono de flecha 1',
      svgString: '',
      colorable: false,
    },
    errorIcon: {
      key: 'error',
      path: '/assets/icons/error.svg',
      alt: 'Icono de error',
      svgString: '',
      colorable: false,
    },
    elipseBurgerIcon: {
      key: 'burger.elipse',
      path: '/assets/burger-menu/Ellipse.svg',
      alt: 'Icono de elipse del menú hamburguesa',
      svgString: '',
      colorable: false,
    },
    barsBurgerIcon: {
      key: 'burger.bars',
      path: '/assets/burger-menu/bars.svg',
      alt: 'Icono de barras del menú hamburguesa',
      svgString: '',
      colorable: false,
    },
    numberOneIcon: {
      key: 'numbers.one',
      path: '/assets/icons/1.svg',
      alt: 'Icono de número uno',
      svgString: '',
      colorable: false,
    },
    lineIcon: {
      key: 'line',
      path: '/assets/icons/line.svg',
      alt: 'Icono de línea',
      svgString: '',
      colorable: false,
    },
    numberTwoIcon: {
      key: 'numbers.two',
      path: '/assets/icons/2.2.svg',
      alt: 'Icono de número dos',
      svgString: '',
      colorable: false,
    },
    workerIcon: {
      key: 'worker',
      path: '/assets/icons/worker.svg',
      alt: 'Icono de trabajador',
      svgString: '',
      colorable: false,
    },
    numberThreeIcon: {
      key: 'numbers.three',
      path: '/assets/icons/3.2.svg',
      alt: 'Icono de número tres',
      svgString: '',
      colorable: false,
    },
    numberFourIcon: {
      key: 'numbers.four',
      path: '/assets/icons/4.2.svg',
      alt: 'Icono de número cuatro',
      svgString: '',
      colorable: false,
    },
    calendarIcon: {
      key: 'calendar',
      path: '/assets/icons/calendar.svg',
      alt: 'Icono de calendario',
      svgString: '',
      colorable: false,
    },
    homeIcon: {
      key: 'home',
      path: '/assets/icons/House.svg',
      alt: 'Icono de inicio',
      svgString: '',
      colorable: false,
    },
    usersIcon: {
      key: 'users',
      path: '/assets/icons/users.svg',
      alt: 'Icono de usuarios',
      svgString: '',
      colorable: false,
    },
    clientsIcon: {
      key: 'clients',
      path: '/assets/icons/office_bag.svg',
      alt: 'Icono de clientes',
      svgString: '',
      colorable: false,
    },
    departmentsIcon: {
      key: 'departments',
      path: '/assets/icons/centros_trabajo.svg',
      alt: 'Icono de departamentos',
      svgString: '',
      colorable: false,
    },
    campaignsIcon: {
      key: 'campaigns',
      path: '/assets/icons/campana.svg',
      alt: 'Icono de campañas',
      svgString: '',
      colorable: false,
    },
    resultsIcon: {
      key: 'results',
      path: '/assets/icons/resultados.svg',
      alt: 'Icono de resultados',
      svgString: '',
      colorable: false,
    },
    reportsIcon: {
      key: 'reports',
      path: '/assets/icons/reportes.svg',
      alt: 'Icono de reportes',
      svgString: '',
      colorable: false,
    },
    helpIcon: {
      key: 'help',
      path: '/assets/icons/chat.svg',
      alt: 'Icono de ayuda',
      svgString: '',
      colorable: false,
    },
    logoutIcon: {
      key: 'logout',
      path: '/assets/icons/logout.svg',
      alt: 'Icono de cerrar sesión',
      svgString: '',
      colorable: false,
    },
  },
  content: {
    global: {
      appName: 'NOM-035',
      appDescription: 'Software de evaluación para la NOM035',
      appVersion: '1.0.0',
    },
    welcome: {
      title: 'BIENVENIDO',
      subtitle: 'Selecciona alguna de las opciones del menú para configurar',
    },
    shared: {
      confirmDeleteDialog: {
        title: '¿Deseas eliminar este registro?',
        warningMessage: 'Esta acción es irreversible.',
        cancelButton: 'Cancelar',
        deleteButton: 'Eliminar',
      },
      bulkUploadModal: {
        title: 'Carga masiva de datos',
        firstStepTitle: '1. Obtener formato',
        secondStepTitle: '2. Subir modificaciones',
        downloadTemplateInstructionsLabel:
          'Descarga el formato de carga masiva con la información de los empleados, modifícalo y ve al siguiente paso.',
        backButton: 'Atrás',
        nextButton: 'Siguiente',
        uploadFileLabel:
          'Sube un archivo .xlsx o .csv con los encabezados recomendados. Tamaño máximo: 5 MB.',
        dragAndDropLabel: 'Arrastra y suelta el archivo aquí',
        selectFileLabel: 'Seleccionar archivo',
      },
      campaignStepsModal: {
        title: 'Pasos para generar una campaña',
        registerClientFirstStep: 'Registro de cliente',
        createOcupationSecondStep: 'Crear ocupación',
        createDepartmentThirdStep: 'Crear departamento',
        createCampaignFourthStep: 'Crear campaña',
        confirmButton: 'Entendido',
      },
      loadingModal: {
        loadingTitle: 'Cargando...',
        loadingMessage: 'Por favor espera',
      },
      titleHelpComponent: {
        title: 'Seguridad en la información personal de los empleados',
      },
      emptyStateComponent: {
        title: 'No hay suficientes datos para generar el reporte.',
      },
      legendLevel: {
        label: "Nivel de riesgo",
        veryLowRisk: 'Muy bajo',
        lowRisk: 'Bajo',
        mediumRisk: 'Medio',
        highRisk: 'Alto',
        veryHighRisk: 'Muy alto',
      },
    },
    usersComponent: {
      clientFilterInstruction: 'Filtrar por cliente',
      deleteUserMessage: 'Se eliminará al usuario :',
    },
    usersFormComponent: {
      nameLabel: 'Nombre(s) *',
      nameError: 'El nombre es requerido y no puede estar vacío',
      lastNameLabel: 'Apellido(s) *',
      lastNameError: 'El apellido es requerido y no puede estar vacío',
      usernameLabel: 'Nombre de usuario *',
      usernameError: 'El nombre de usuario es requerido y no puede estar vacío',
      emailLabel: 'Correo electrónico *',
      emailError: 'El correo electrónico es requerido y no puede estar vacío',
      clientLabel: 'Cliente',
      clientError: 'El cliente es requerido',
      passwordLabel: 'Contraseña',
      passwordRequired: 'La contraseña es requerida',
      passwordMinLengthError: 'La contraseña debe tener al menos 6 caracteres',
      confirmPasswordLabel: 'Confirmar contraseña *',
      confirmPasswordError: 'La confirmación de contraseña es requerida',
      passwordMismatchError: 'Las contraseñas no coinciden',
      cancelButton: 'Cancelar',
      saveButton: 'Guardar',
      updateButton: 'Actualizar',
    },
    clientsComponent: {
      title: 'Clientes',
      description: 'Administra los clientes registrados, puedes seleccionar cualquiera de ellos para consultar o modificar su información, así como crear un nuevo usuario si así lo requiere.',
      searchClientInstruction: 'Buscar cliente',
      deleteClientMessage: '¿Está seguro que desea eliminar el registro?',
      deleteClientWarning: 'Esta acción es irreversible.',
    },
    tableComponent: {
      previousLabel: 'Anterior',
      nextLabel: 'Siguiente',
      noDataLabel: 'No se encontraron registros',
    },
    clientsFormComponent: {
      title: 'Crear cliente',
      subtitle: 'Completa sus datos para registrarlo',
      editTitle: 'Editar cliente',
      editSubtitle: 'Actualiza su información y da click en Guardar al finalizar',
      cancelButton: 'Cancelar',
      companyNameLabel: 'Nombre de la empresa *',
      companyNameError:
        'El nombre de la empresa es requerido y no puede estar vacío',
      rfcLabel: 'RFC *',
      rfcErrorRequired: 'El RFC es requerido',
      rfcFormatError: 'El RFC debe tener un formato válido',
      corporateNameLabel: 'Razón social de la empresa*',
      corporateNameError:
        'La razón social de la empresa es requerida y no puede estar vacía',
      fiscalAddressLabel: 'Domicilio fiscal',
      campaignResponsibleLabel: 'Responsable de la campaña',
      emailLabel: 'Correo electrónico',
      emailFormatError: 'El correo electrónico debe tener un formato válido',
      contactNumberLabel: 'Teléfono de contacto',
      contactLengthError:
        'El teléfono de contacto debe contener exactamente 10 dígitos',
      updateButton: 'Actualizar',
      saveButton: 'Guardar',
    },
    departmentsComponent: {
      departmentNameLabel: 'Nombre del departamento *',
      departmentNameError:
        'El nombre del departamento es requerido y no puede estar vacío',
      cancelButton: 'Cancelar',
      saveButton: 'Guardar',
      searchDepartmentInstruction: 'Buscar departamento',
    },
    campaignsComponent: {
      searchCampaignInstruction: 'Buscar campaña',
    },
    campaignsFormComponent: {
      createCampaignTitle: 'Crear campaña',
      createCampaignDescription: "Crea una nueva campaña para evaluar el entorno laboral de tus empleados.",
      generateTokensButton: 'Generar tokens',
      campaignNameLabel: 'Nombre de la campaña *',
      campaignNameError:
        'El nombre de la campaña es requerido y no puede estar vacío',
      campaignDescriptionLabel: 'Descripción de la campaña',
      surveyURLLabel: 'URL de la encuesta',
      campaignStartDateLabel: 'Fecha de inicio de la campaña *',
      startDateRequiredError: 'La fecha de inicio de la campaña es requerida',
      startDateInvalidError:
        'La fecha de inicio de la campaña debe ser posterior al día de hoy',
      campaignEndDateLabel: 'Fecha de fin de la campaña *',
      endDateRequiredError: 'La fecha de fin de la campaña es requerida',
      endDateBeforeStartError:
        'La fecha de fin de la campaña debe ser posterior a la fecha de inicio',
      totalEmployeesLabel: 'Total de empleados *',
      totalEmployeesRequiredError: 'El total de empleados es requerido',
      totalEmployeesZeroError: 'El total de empleados debe ser mayor a 0',
      minRequiredLabel: 'Mínimo requerido',
      tokensToGenerateLabel: 'Tokens a generar *',
      tokensToGenerateRequiredError: 'Los tokens a generar son requeridos',
      tokensToGenerateZeroError: 'Los tokens a generar deben ser mayores a 0',
      tokensToGenerateExceedError:
        'Los tokens a generar no pueden exceder el total de empleados',
      tokensToGenerateMinError:
        'Los tokens a generar no pueden ser menores al total de empleados',
      assignedCampaignLabel: 'Campaña asignada',
      generateTokensMessageWarning:
        'Ya tienes el límite de tokens según la cantidad de empleados',
      generateTokensRequiredError: 'El número de tokens es requerido.',
      generateTokensLessError:
        'No puedes generar menos tokens de los que ya tienes',
      generateTokensExceedError:
        'No puedes generar más tokens que el total de empleados',
      generateTokensGenerateButton: 'Generar tokens',
      tokensExportCSVButton: 'Exportar a CSV',
      tokensExportExcelButton: 'Exportar a Excel',
      returnToCampaignsList: 'Volver al listado de campañas',
      returnToListOfCampaigns: 'Ir a la lista de campañas',
    },
    resultsComponent: {
      title: 'Resultados',
      description: 'Bienvenido al sistema de gestión NOM-035',
      chooseClientLabel: 'Elegir otro cliente',
      chooseClientAndCampaignLabel:
        'Seleccione un cliente y una campaña para ver los resultados',
      chooseCampaignLabel: 'Seleccione una campaña para ver los resultados',
      noSurveysMessage: 'No hay cuestionarios disponibles',
      placeholderSelectClient: 'Seleccionar cliente',
      placeHolderSelectCampaign: 'Seleccionar campaña',
      responsesSubtitle: 'Total de cuestionarios respondidos:',
      responsesTitle: 'Cuestionario',
      resultsTableTitle: 'Cuestionarios respondidos',
    },
    guideOneComponent: {
      emptyStateMessage: 'El cuestionario de la GUIA I aún no tiene respuestas',
      backButton: 'Regresar',
    },
    guideTwoComponent: {
      emptyStateMessage: 'El cuestionario de la GUIA II aún no tiene respuestas',
      backButton: 'Regresar',
    },
    guideThreeComponent: {
      emptyStateMessage:
        'El cuestionario de la GUIA III aún no tiene respuestas',
      backButton: 'Regresar',
    },
    guideComponent: {
      title: 'Resultados para la',
      description: 'Resumen de la evaluación de factores de riesgo psicosocial',
      backButton: 'Regresar',
      sectionTitle: 'Suma total de valores',
      totalScoreLabel: 'Suma total:',
      evaluationResultsLabel: 'Nivel de riesgo:',
      scoreExplanationLabel: 'Esta es la SUMA de todos los valores de las respuestas, por ejemplo: 3 respuestas "Siempre", valor de 4 cada una es igual a 12 puntos en total.',
      totalCategoryLabel: 'Suma por categorías:',
      totalDomainLabel: 'Suma por dominios:',
      totalDimensionLabel: 'Suma por dimensiones:',
      scoreExplanation:
        '(Todas estas sumas deben ser iguales al total general de 125 puntos, ya que representan las mismas respuestas agrupadas de diferentes maneras)',
    },
    clientCampaignsComponent: {
      title: 'Campaña',
      titleTable: 'Información de campaña',
      campaignStartDateLabel: 'Inicio de campaña',
      campaignEndDateLabel: 'Fin de campaña',
      campaignDurationLabel: 'Duración de campaña',
      campaignResponsibleLabel: 'Responsable de campaña',
    },
    reports: {
      guideOneReportComponent: {
        title: 'Reporte de Guía de referencia I',
      },
      guideTwoReportComponent: {
        title: 'Reporte de Guía de referencia II',
      },
      guideThreeReportComponent: {
        title: 'Reporte de Guía de referencia III',
      },
      legendLevelComponent: {
        label: 'Nivel de riesgo',
        veryLowRisk: 'Muy bajo',
        lowRisk: 'Bajo',
        mediumRisk: 'Medio',
        highRisk: 'Alto',
        veryHighRisk: 'Muy alto',
      },
      reportControlsComponent: {
        filterButton: 'Filtros',
        exportButton: 'Generando PDF...',
        generatingPDFMessage: 'Exportar',
      },
      severeTraumaticEventContent: {
        title: '¿Qué significa un acontecimiento traumático severo?',
        descriptionPartOne:
          'Un acontecimiento traumático severo es una experiencia extrema que pone en riesgo la vida o la integridad física o emocional de una persona, en situaciones como accidentes graves, asaltos, desastres naturales o la muerte violenta de un ser querido.',
        descriptionPartTwo:
          'Puede provocar síntomas como ansiedad, miedo intenso, insomnio o estrés postraumático.',
        descriptionPartThree:
          'En el ámbito laboral, debe ser atendido conforme a la NOM-035 para proteger la salud mental del trabajador.',
      },
      corporateCompanyNameContent: {
        title: 'Razón social organizacional',
        companyNameLabel: 'Nombre de la empresa:',
        evaluationLabel: 'Evaluación:',
        evaluationContent: 'Guía de referencia I NOM-035',
        workersLabel: 'Trabajadores:',
        metodologyLabel: 'Metodología:',
        metodologyContent: ' Identificación de colaboradores sujetos a un Acontecimiento traumático severo durante o con motivos laborales.',
        campaignStartLabel: 'Inicio de campaña:',
        campaignEndLabel: 'Fin de campaña:',
        campaignDurationLabel: 'Duración de campaña:',
        loadingLabel: 'Cargando...',
      },
      nextStepsContent: {
        title: 'Siguientes pasos',
        descriptionPartOne:
          'A continuación te mostramos los pasos a seguir si tus resultados encontraron a 1 o más personas identificadas con Acontecimiento traumático severo:',
        firstStepTitle: 'Canalización inmediata',
        firstStepDescription:
          'Derivar a la persona identificada a atención psicológica especializada, ya sea interna o externa.',
        secondStepTitle: 'Seguimiento personalizado',
        secondStepDescription:
          'Monitorear el estado emocional y laboral de la persona con discreción y continuidad',
        thirdStepTitle: 'Evaluación del entorno laboral',
        thirdStepDescription:
          'Revisar si existen factores organizacionales que puedan agravar el impacto del evento traumático.',
        fourthStepTitle: 'Capacitación y sensibilización',
        fourthStepDescription:
          'Ofrecer talleres o sesiones informativas al equipo para fomentar un ambiente empático y de apoyo.',
        fifthStepTitle: 'Reforzamiento de medidas preventivas',
        fifthStepDescription:
          'Actualizar o implementar protocolos de prevención y atención de riesgos psicosociales.',
      },
      donutCardComponent: {
        title: 'Personas evaluadas hasta el momento',
        totalOfSurveysLabel: 'de un total de',
        employeesLabel: 'empleados',
        evaluatedLabel: 'Evaluados',
        notEvaluatedLabel: 'Sin evaluar',
        severeTraumaticEventTitle:
          'Personas identificadas con acontecimiento traumático severo',
        severeTraumaticEventLabel: 'Con acontecimiento traumático severo',
        noSevereTraumaticEventLabel: 'Sin acontecimiento traumático severo',
      },
      barCardComponent: {
        title: 'Colaboradores por rango de edad',
      },
      multiDonutCardComponent: {
        title: 'Personas identificadas por género',
      },
      reportPreviewComponent: {
        positiveFactorsTitle: 'Factores positivos',
        negativeFactorsTitle: 'Factores negativos',
        emptyStateMessage: 'No hay resultados para los filtros seleccionados.',
      },
      reportDetailComponent: {
        domainLabel: 'Dominio',
        peopleLabel: 'Personas',
        levelLabel: 'Nivel',
      },
      reportScenearioComponent: {
        cleanFiltersButton: 'Limpiar filtros',
        selectCampaignLabel:
          'Seleccionar una campaña para ver los resultados',
      },
      domainScoresBreakdownComponent: {
        title: 'Nivel de riesgo por dominio',
      },
      emptyStateComponent: {
        title: 'Sin resultados para datos de distribución',
        description:
          'No encontramos resultados con los filtros seleccionados. Ajusta los filtros demográficos o cambia la campaña e inténtalo de nuevo.',
      },
      reportFiltersDialog: {
        title: 'Panel de configuración del análisis',
        cancelButton: 'Cancelar',
        applyButton: 'Aplicar filtros',
      },
      reportFiltersComponent: {
        title: 'Filtros',
        chooseReportTypeLabel: '1. Elige el tipo de reporte',
        generalReportOption: 'Reporte general',
        categoryReportOption: 'Reporte por categoría',
        domainReportOption: 'Reporte por dominio',
        dimensionReportOption: 'Reporte por dimensión',
        demographicFiltersLabel:
          'Selecciona uno o más filtros demográficos',
        cleanDemographicFiltersButton: 'Limpiar',
        adjustFiltersValuesLabel: 'Ajustar filtros',
        cleanFiltersValuesButton: 'Limpiar',
      },
    },
    helpComponent: {
      helpSection: {
        firstPartOfSupportDescription:
          'Si requieres atención personalizada, levanta un ticket en el siguiente link:',
        linkToSupportLabel: 'mailto:contactanos@afirma-solutions.com',
        lastPartOfSupportDescription:
          'y alguien de nuestro equipo lo contactará',
      },
      policiesSection: {
        firstPolicySectionTitle: 'Cómo protegemos tu información personal',
        firstPolicySectionDescription:
          'La privacidad de los datos de los usuarios es de gran importancia para el titular de esta web y por ello toda información referente a los usuarios recibida por el titular de esta página web es tratada con la máxima confidencialidad. El titular de esta web ha adoptado las medidas y niveles de seguridad de protección de los datos personales exigidos por la normativa vigente, habida cuenta en todo momento del estado de la tecnología, y desea mantener una actitud abierta y transparente al tratar los datos personales.',
        secondPolicySectionTitle:
          '¿Quién es el responsable del tratamiento de los datos personales?',
        secondPolicySectionDescription:
          'El titular de esta web es el responsable del tratamiento de los datos personales que los usuarios le proporcionan y se responsabiliza de los referidos datos personales de acuerdo con la normativa aplicable en materia de protección de datos, cualquier modificación o solicitud puede realizarse a través del correo: info-mexico@afirma.solutions',
        thirdPolicySectionTitle:
          '¿Qué datos personales se recopilan en esta web y para qué?',
        thirdPolicySectionDescription: `a) En los formularios de contacto: Nombre y dirección de correo electrónico del usuario.\n\nEl titular de esta web utiliza los datos personales obtenidos en los formularios de contacto para poder contestar a las preguntas o peticiones que le solicite el usuario.\n\nb) En relación con el uso de cookies: Datos de navegación anónima a través de las páginas web.\n\nEl nombre de dominio del proveedor (ISP) que da acceso a la red. Por ejemplo, un usuario del proveedor XXX solo estará identificado con el dominio xxx.es. De esta manera, se pueden elaborar estadísticas sobre los países y servidores que visitan más a menudo la web.\n\nLa fecha y hora de acceso a la web. Permite averiguar las horas de mayor afluencia, y hacer los ajustes precisos para evitar problemas de acceso.\n\nEl número de visitantes diarios de cada sección. Permite conocer las áreas de mayor interés y aumentar y mejorar su contenido, con el fin de que los usuarios obtengan un resultado más satisfactorio.\n\nEl tipo de dispositivo, sistema operativo y navegador utilizado. Permite conocer estadísticas sobre los dispositivos utilizados por los usuarios y ajustar el contenido a sus características técnicas, con el fin de que los usuarios obtengan un resultado más satisfactoratorio.`,
        fourthPolicySectionTitle: '¿A quién se comunican sus datos?',
        fourthPolicySectionDescription:
          'El titular de esta página web no traspasa, vende ni intercambia los datos personales de sus usuarios con terceras partes. ¿Cuál es la base legal para el tratamiento de sus datos personales? En cada tratamiento específico de datos personales recopilados sobre el usuario, se le informará si la comunicación de datos personales es un requisito legal o un requisito necesario para suscribir un contrato, y si está obligado a facilitar los datos personales, así como de las posibles consecuencias de no facilitar tales datos.',
        fifthPolicySectionTitle: '¿Cuáles son sus derechos?',
        fifthPolicySectionDescription: `Derecho de acceso: Cualquier persona tiene derecho a obtener confirmación sobre si en esta página web se están tratando datos personales que les conciernan, o no. Usted puede contactar con el titular de la web y éste le remitirá los datos personales que trata sobre usted por email.\n\nDerecho de portabilidad: Siempre que el titular de esta web procese sus datos personales a través de medios automatizados en base a su consentimiento o a un acuerdo, usted tiene derecho a obtener una copia de sus datos en un formato estructurado, de uso común y lectura mecánica transferida a su nombre o a un tercero. En ella se incluirán únicamente los datos personales que usted nos haya facilitado.\n\nDerecho de rectificación: Usted tiene derecho a solicitar la rectificación de sus datos personales si son inexactos, incluyendo el derecho a completar datos que figuren incompletos.\n\nDerecho de supresión: Usted tiene derecho a obtener sin dilación indebida la supresión de cualquier dato personal suyo tratado por el titular de esta web en cualquier momento, excepto en las siguientes situaciones:\n\nSi la información es necesaria para la formulación, el ejercicio o la defensa de reclamaciones del titular de la web, del usuario o de terceros.\nSi la información ha sido solicitada por las autoridades competentes.\nSi se sospecha o está confirmado que ha utilizado incorrectamente los servicios de la web en los últimos cuatro años.\nDerecho de oposición al tratamiento de datos en base al interés legítimo: Usted tiene derecho a oponerse al tratamiento de sus datos personales en base al interés legítimo del titular de esta página web. El titular de esta web no seguirá tratar los datos personales a menos que podamos acreditar motivos legítimos imperiosos para el tratamiento que prevalezcan sobre sus intereses, derechos y libertades, o bien para la formulación, el ejercicio o la defensa de reclamaciones.\n\nDerecho a presentar una reclamación ante una autoridad de control: Si usted considera que el titular de esta web trata sus datos de un modo incorrecto, puede contactar con él dirigiéndose a la dirección de correo ordinario o electrónico del titular de la página web. También tiene derecho a presentar una queja ante la autoridad de protección de datos competente.\n\nDerecho a la limitación en el tratamiento: Usted tiene derecho a solicitar que el titular de esta web limite el tratamiento de sus datos personales en las siguientes circunstancias:\n\nSi usted se opone al tratamiento de sus datos en base al interés legítimo de del titular de esta web, éste deberá limitar cualquier tratamiento de dichos datos a la espera de la verificación del interés legítimo.\nSi usted reclama que sus datos personales son incorrectos, el titular de esta web debe limitar cualquier tratamiento de dichos datos hasta que se verifique la precisión de los mismos.\nSi el tratamiento es ilegal, usted podrá oponerse a que se eliminen los datos personales y, en su lugar, solicitar la limitación de su uso.\nSi el titular de esta web ya no necesita los datos personales, pero usted los necesita para la formulación, el ejercicio o la defensa de reclamaciones.\nEjercicio de derechos: Para cuestiones relacionadas con el ejercicio de sus derechos o para cualquier otra información o aclaración al respecto, se dirija a la dirección de correo ordinario o electrónico del titular de la página web.`,
      },
      contactSection: {
        firstPartOfContactDescription:
          'Si requieres atención personalizada, contáctanos por',
        linkToContactLabel: 'mailto:contactanos@afirma-solutions.com',
        lastPartOfContactDescription:
          'en un horario de Lunes a Viernes de 8:00 AM a 8:00 PM.',
      },
    },
    authComponent: {
      actionTokenComponent: {
        processingTokenMessage: 'En proceso de validación. Por favor espere…',
      },
      resetPasswordComponent: {
        title: '¿Olvidaste tu contraseña?',
        instructionsLabel:
          'Escribe tu email y recibe las instrucciones para recuperarla.',
        emailRequiredError: 'El correo electrónico es requerido.',
        emailFormatError:
          'El correo electrónico debe tener un formato correcto.',
        cancelButton: 'Cancelar',
        nextButton: 'Siguiente',
      },
      createNewPasswordComponent: {
        title: 'Crea una nueva contraseña',
        descriptionLabel: 'Llena los campos para reestabelecer tu contraseña',
        newPasswordLabel: 'Nueva Contraseña',
        confirmNewPasswordLabel: 'Confirmar contraseña',
        newPasswordRequiredError: 'La nueva contraseña es obligatoria',
        newPasswordFormatError:
          'La contraseña debe tener al menos 6 caracteres, y contener un carácter especial',
        confirmNewPasswordRequiredError:
          'La confirmación de contraseña es obligatoria',
        passwordMismatchError:
          'Las contraseñas no coinciden. Por favor, verifica que ambas sean iguales',
        cancelButton: 'Cancelar',
        nextButton: 'Siguiente',
      },
      loginComponent: {
        welcomeLabel: 'Bienvenido',
        descriptionLabel: 'Software para la NOM-035-STPS-2018',
        emailLabel: 'Email',
        passwordLabel: 'Contraseña',
        instructionsLabel: 'Ingresa todos tus datos para continuar',
        emailOrPasswordError:
          'El email ó contraseña que ingresaste es incorrecto, favor de revisarlo',
        errorToLogin:
          'Hubo un problema al procesar tu inicio de sesión. Por favor, inténtalo de nuevo',
        forgotPasswordLabel: '¿Olvidaste tu contraseña?',
        loginButton: 'Iniciar',
      },
      successMessageComponent: {
        emailVerfiedTitle: 'Correo validado correctamente',
        emailVerfiedMessage:
          'Su correo ha sido validado correctamente. Ahora puede iniciar sesión en la plataforma.',
        continueToLoginButton: 'Regresar al inicio',
        resetPasswordTitle: '¡Correo enviado!',
        resetPasswordMessage:
          'Correo enviado, continúa el proceso en la bandeja de tu correo',
        backToLoginButton: 'Entendido',
      },

    },
  },
};
